import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography,
} from "@mui/material";

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        pt: 5,
        pb: 4,
        borderTop: "1px solid",
        borderColor: "divider",
        background: "linear-gradient(90deg, #e6e5df, #f2f1ee)",
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3} alignItems="center" textAlign="center">
          {/* Decorative divider */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Divider sx={{ width: 60 }} />
            <FavoriteRoundedIcon sx={{ fontSize: 18, opacity: 0.7 }} />
            <Divider sx={{ width: 60 }} />
          </Stack>

          {/* Contact section */}
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, letterSpacing: 0.5 }}
            >
              Contact
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Phone: +358 40 372 4121
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Email: chrharju@gmail.com
            </Typography>
          </Box>

          {/* Attribution */}
          <Box>
            <Typography variant="body2" color="text.secondary">
              Website created by Toffe @{" "}
              <Link
                href="https://codekatu.com"
                target="_blank"
                rel="noreferrer"
                underline="hover"
                color="inherit"
              >
                Codekatu Oy
              </Link>
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
